module.exports = __webpack_public_path__ + "static/media/sainsburys.ce376602.jpg";